import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Lock, Clock } from 'lucide-react';
export function PurchaseSection() {
  const [selected, setSelected] = useState<'base' | 'completa'>('completa');
  const [timeLeft, setTimeLeft] = useState(() => {
    const saved = localStorage.getItem('offerExpiry');
    if (saved) {
      const remaining = Math.max(0, Math.floor((parseInt(saved) - Date.now()) / 1000));
      if (remaining > 0) return remaining;
    }
    const expiry = Date.now() + 24 * 60 * 60 * 1000;
    localStorage.setItem('offerExpiry', expiry.toString());
    return 24 * 60 * 60;
  });
  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  return <section id="compra" className="bg-white py-1 md:py-24 px-2 md:px-4 scroll-mt-10" data-id="element-225">
      <div className="max-w-2xl mx-auto" data-id="element-226">
        {/* COUNTDOWN TIMER */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-1.5 md:mb-8" data-id="element-227">
          <div className="bg-navy rounded-lg md:rounded-2xl p-2 md:p-5 text-center" data-id="element-228">
            <p className="text-gold/80 text-[10px] md:text-sm font-semibold tracking-wider uppercase flex items-center justify-center gap-1 md:gap-2 mb-1 md:mb-3" data-id="element-229">
              <Clock size={11} className="animate-pulse md:w-4 md:h-4" data-id="element-230" />
              La oferta expira en:
            </p>
            <div className="flex items-center justify-center gap-1.5 md:gap-3" data-id="element-231">
              <div className="bg-white/10 rounded-md md:rounded-xl px-2.5 md:px-4 py-1.5 md:py-3 min-w-[48px] md:min-w-[72px]" data-id="element-232">
                <p className="text-white text-xl md:text-4xl font-bold font-mono leading-none" data-id="element-233">
                  {String(hours).padStart(2, '0')}
                </p>
                <p className="text-gold/60 text-[8px] md:text-[10px] uppercase tracking-wider mt-0.5 md:mt-1" data-id="element-234">
                  Horas
                </p>
              </div>
              <span className="text-gold text-xl md:text-3xl font-bold animate-pulse" data-id="element-235">
                :
              </span>
              <div className="bg-white/10 rounded-md md:rounded-xl px-2.5 md:px-4 py-1.5 md:py-3 min-w-[48px] md:min-w-[72px]" data-id="element-236">
                <p className="text-white text-xl md:text-4xl font-bold font-mono leading-none" data-id="element-237">
                  {String(minutes).padStart(2, '0')}
                </p>
                <p className="text-gold/60 text-[8px] md:text-[10px] uppercase tracking-wider mt-0.5 md:mt-1" data-id="element-238">
                  Minutos
                </p>
              </div>
              <span className="text-gold text-xl md:text-3xl font-bold animate-pulse" data-id="element-239">
                :
              </span>
              <div className="bg-white/10 rounded-md md:rounded-xl px-2.5 md:px-4 py-1.5 md:py-3 min-w-[48px] md:min-w-[72px]" data-id="element-240">
                <p className="text-white text-xl md:text-4xl font-bold font-mono leading-none" data-id="element-241">
                  {String(seconds).padStart(2, '0')}
                </p>
                <p className="text-gold/60 text-[8px] md:text-[10px] uppercase tracking-wider mt-0.5 md:mt-1" data-id="element-242">
                  Segundos
                </p>
              </div>
            </div>
          </div>
        </motion.div>

        {/* TITLE */}
        <div className="text-center mb-1.5 md:mb-12" data-id="element-243">
          <h2 className="text-xl md:text-5xl font-bold text-navy mb-0.5 md:mb-4" data-id="element-244">
            Tu bebé se merece dormir bien. Vos también.
          </h2>
          <p className="text-xs md:text-xl text-navy/60" data-id="element-245">Elegi tu plan:</p>
        </div>

        <div className="flex flex-col gap-1.5 md:gap-4" data-id="element-246">
          {/* ORDER BUMP 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} onClick={() => setSelected('base')} className={`relative rounded-lg md:rounded-xl p-2 md:p-5 cursor-pointer transition-all border ${selected === 'base' ? 'border-navy/30 bg-navy/5' : 'border-gray-200 bg-gray-50'}`} data-id="element-247">
            <div className="flex items-center gap-2.5 md:gap-4" data-id="element-248">
              <div className="flex-shrink-0" data-id="element-249">
                <div className={`w-4 h-4 rounded-full border-2 flex items-center justify-center ${selected === 'base' ? 'border-gold' : 'border-gray-300'}`} data-id="element-250">
                  {selected === 'base' && <div className="w-2 h-2 rounded-full bg-gold" data-id="element-251" />}
                </div>
              </div>
              <div className="flex-1 min-w-0" data-id="element-252">
                <p className="text-gold text-[9px] md:text-xs font-bold tracking-wider mb-0 md:mb-1" data-id="element-253">
                  ⭐ SISTEMA ORIGINAL
                </p>
                <h3 className="text-sm md:text-xl font-bold text-navy leading-tight" data-id="element-254">
                  Método Noches de Paz™
                </h3>
                <p className="text-navy/50 text-[10px] md:text-sm" data-id="element-255">
                  6 Tomos + 3 Bonus
                </p>
              </div>
              <div className="text-right flex-shrink-0" data-id="element-256">
                <p className="text-navy/40 text-[10px] md:text-sm line-through" data-id="element-257">
                  $39.990
                </p>
                <p className="text-gold font-bold text-lg md:text-3xl" data-id="element-258">
                  $19.990
                </p>
              </div>
            </div>
          </motion.div>

          {/* ORDER BUMP 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="relative" data-id="element-259">
            {/* Recommended badge */}
            <div className="text-center mb-0" data-id="element-260">
              <div className="inline-block bg-navy text-gold border border-gold/40 rounded-t-lg md:rounded-t-xl px-3 md:px-6 py-1 md:py-2" data-id="element-261">
                <p className="text-gold text-[9px] md:text-xs font-bold tracking-wider" data-id="element-262">
                  🏆 LA MEJOR OPCIÓN PARA NO FALLAR
                </p>
              </div>
            </div>

            <div onClick={() => setSelected('completa')} className={`relative rounded-lg md:rounded-xl rounded-t-none p-2 md:p-5 cursor-pointer transition-all border-2 ${selected === 'completa' ? 'border-gold bg-navy/5' : 'border-gold/30 bg-gray-50'}`} data-id="element-263">
              <div className="flex items-center gap-2.5 md:gap-4" data-id="element-264">
                <div className="flex-shrink-0" data-id="element-265">
                  <div className={`w-4 h-4 rounded-full border-2 flex items-center justify-center ${selected === 'completa' ? 'border-gold' : 'border-gray-300'}`} data-id="element-266">
                    {selected === 'completa' && <div className="w-2 h-2 rounded-full bg-gold" data-id="element-267" />}
                  </div>
                </div>
                <div className="flex-1 min-w-0" data-id="element-268">
                  <p className="text-gold text-[9px] md:text-xs font-bold tracking-wider mb-0 md:mb-1" data-id="element-269">
                    👑 PACK COMPLETO
                  </p>
                  <h3 className="text-sm md:text-xl font-bold text-navy leading-tight" data-id="element-270">
                    Edición Completa 💎
                  </h3>
                  <p className="text-navy/50 text-[10px] md:text-sm" data-id="element-271">
                    6 Tomos + 3 Bonus + Noches Difíciles + Dormir Sin Culpa
                  </p>
                </div>
                <div className="text-right flex-shrink-0" data-id="element-272">
                  <p className="text-navy/40 text-[10px] md:text-sm line-through" data-id="element-273">
                    $59.990
                  </p>
                  <p className="text-gold font-bold text-lg md:text-3xl" data-id="element-274">
                    $29.990
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* CTA BUTTON */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="mt-0 md:mt-2" data-id="element-275">
            <a href={selected === 'completa' ? 'https://casaenpaz.com.ar/checkouts/cn/hWNBKEXVjWQbuNXLZI732R5W/es-ar?_r=AQABdtZJvOu5PakMc-ms_X1mkEiWKOog0BaSIeqjdorYvJI' : 'https://casaenpaz.com.ar/checkouts/cn/hWNBKEFU3MSDCS9WoSgveGmI/es-ar?_r=AQABEVJbYZtskdXm1yaFkWkQDv534SW9LE_ET2s8d8RJ2M4'} className="block w-full text-center bg-[#1e3a5f] hover:bg-[#2a4f7a] text-white text-sm md:text-xl font-extrabold uppercase tracking-wide py-4 md:py-5 px-5 md:px-8 rounded-xl md:rounded-2xl shadow-[0_0_30px_rgba(30,58,95,0.6)] transition-all transform hover:scale-[1.02] animate-pulse" data-id="element-276">
              {selected === 'completa' ? 'ADQUIRIR EDICIÓN COMPLETA AHORA' : 'ADQUIRIR MÉTODO NOCHES DE PAZ™ AHORA'}
            </a>
            <p className="text-center text-navy/50 text-[10px] md:text-sm mt-0.5 md:mt-2" data-id="element-277">
              ${selected === 'completa' ? '29.990' : '19.990'} · Acceso
              Inmediato
            </p>
          </motion.div>

          {/* DESCRIPTION CARD */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="bg-gray-50 rounded-lg md:rounded-2xl p-2 md:p-6 mt-0 md:mt-2 border border-gray-200" data-id="element-278">
            <h4 className="text-navy font-bold text-xs md:text-lg mb-1 md:mb-4" data-id="element-279">
              La solución para mamás que quieren dormir:
            </h4>
            <div className="space-y-0.5 md:space-y-2 text-navy/70 text-[10px] md:text-sm" data-id="element-280">
              <p data-id="element-281">
                <span className="font-bold text-navy" data-id="element-282">
                  📘 MÉTODO NOCHES DE PAZ:
                </span>{' '}
                Plan paso a paso con los 6 Tomos + 3 Bonus.
              </p>
              {selected === 'completa' && <>
                  <p data-id="element-283">
                    <span className="font-bold text-navy" data-id="element-284">
                      + 🌙 NOCHES DIFÍCILES:
                    </span>{' '}
                    Te dice qué hacer cuando tu bebé se enferma, está con
                    dientes, entra en regresión o cambia de rutina y el sueño se
                    desordena.
                  </p>
                  <p data-id="element-285">
                    <span className="font-bold text-navy" data-id="element-286">
                      + 💜 DORMIR SIN CULPA:
                    </span>{' '}
                    Te ayuda a aplicar el método con más seguridad emocional,
                    para que tu bebé duerma mejor sin que vos sientas culpa por
                    acompañarlo de esta forma.
                  </p>
                </>}
            </div>
            <p className="text-pink-500 font-bold text-[10px] md:text-sm mt-1 md:mt-4" data-id="element-287">
              Ahorrá ${selected === 'completa' ? '30.000' : '20.000'} solo por
              las próximas 24hs.
            </p>
          </motion.div>
        </div>

        {/* TRUST BADGES */}
        <div className="mt-1.5 md:mt-6 text-center" data-id="element-288">
          <p className="text-[9px] md:text-xs text-navy/40 flex items-center justify-center gap-1" data-id="element-289">
            <Lock size={9} className="md:w-3 md:h-3" data-id="element-290" /> Pago seguro · Acceso
            inmediato · PDF en minutos
          </p>
        </div>
      </div>
    </section>;
}